import { Avatar, Card, Col, Layout, Row, Image, Rate, Badge } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useState } from "react";
import Sidebar from "./sidebar";

import { PhoneFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const CustomerLayout = ({
  children,
  userId,
}: {
  children: ReactElement;
  userId: string;
}): ReactElement => {
  const { customerInfo } = useSelector((state) => (state as any)?.authReducer);

  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content">
                      <div className="pt-4k">
                        <div className="">
                          <Avatar
                            size={150}
                            src={getImgUrl(customerInfo?.profilePicture)}
                          />
                        </div>
                        <div className="body">
                          <h4>{customerInfo?.fullName?.toUpperCase()}</h4>
                          <div className="mb-2">
                            <div>
                              <span className="radius-btn active-btn px-4">
                                <span style={{ fontSize: 14 }}>
                                  Balance:{" "}
                                  {parseInt(customerInfo?.balance) || 0}
                                </span>
                              </span>
                            </div>
                            <Rate
                              value={customerInfo?.rating || 0}
                              className="mt-1"
                              disabled
                            />
                            <small className="ml-1">
                              ({customerInfo?.numberOfRating || 0})
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                <Sidebar userId={userId} />
              </Card>
            </Col>
            <Col span={18}>
              <Card className="product-information-show-tab-wrapper" size="small">
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

CustomerLayout.propType = {
  children: PropTypes.element,
};

export default CustomerLayout;
